/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ max: NonNullable<unknown> }} Error_Online_Price_InvalidInputs */

const vi_error_online_price_invalid = /** @type {(inputs: Error_Online_Price_InvalidInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Giá Online phải là số nguyên đồng từ 1 đến ${i?.max}`)
};

/**

* @param {Error_Online_Price_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_online_price_invalid = /** @type {((inputs: Error_Online_Price_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Online_Price_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_online_price_invalid(inputs)
});